'use strict';

var App = require('app');
var AppState = require('app_state');
var BaseController = require('components/devices/controllers/base_controller');
var HomeController = require('components/home/home_controller');
var MapView = require('components/devices/views/map/map_view');

var MapController = BaseController.extend({
    show: function (params) {
        var self = this;
        HomeController.showBaseLayout({
            cb: function () {
                AppState.layout.breadcrumbs.reset();
                App.trigger('sidebar:default', 'map');

                var deviceBounds = App.request('device:bounds');
                $.when(deviceBounds).done(function (bounds) {
                    if (bounds === undefined) {
                        return;
                    }

                    App.showContentView(
                        new MapView({
                            controller: self,
                            devices: [],
                            bounds: bounds,
                            initialView: params,
                        })
                    );
                });
            },
        });
    },
});

module.exports = MapController;
